import "../styles/transactionForm.css";

const TransactionForm = ({ form, updateField, onSubmit, partner, isSubmitting }) => {
  return (
    <form className="transaction-form" onSubmit={onSubmit}>
      <h4>{partner.name}</h4>

      <input
        type="text"
        placeholder="Scrip"
        value={form.scrip}
        onChange={(e) => updateField("scrip", e.target.value)}
        required
      />

      <input
  type="date"
  value={form.date}
  onChange={(e) => updateField("date", e.target.value)}
  max={new Date().toISOString().split("T")[0]}   // ✅ blocks future dates
  required
/>
      <input
        type="number"
        placeholder="Rate"
        value={form.rate}
        onChange={(e) => updateField("rate", e.target.value)}
        required
      />

      <input
        type="number"
        placeholder="Quantity"
        value={form.quantity}
        onChange={(e) => updateField("quantity", e.target.value)}
        required
      />

      <select
        value={form.transactionType}
        onChange={(e) => updateField("transactionType", e.target.value)}
      >
        <option value="BUY">Buy</option>
        <option value="SELL">Sell</option>
      </select>

      <input
  type="number"
  placeholder="Amount"
  value={form.amount}
  onChange={(e) => updateField("amount", e.target.value)}
  required
/>
      <button
  type="submit"
  disabled={isSubmitting}
>
  {isSubmitting ? "Entering..." : "Submit"}
</button>
    </form>
  );
};

export default TransactionForm;